import React, { useState } from 'react'
import { FullPaymentFragment } from '../../graphql/generated/graphql'
import { Body, Dialog, Spacer } from '@spritz-finance/ui'
import dayjs from 'dayjs'
import { StatusBadge } from '../bills/components/paymentsInProgress/StatusBadge'
import { formatCurrency } from '../../utils/format'
import { ContentContainer, ContentSizer } from '../../components/ConfirmationDialog'
import { DirectPaymentCard } from '../bills/components/paymentsInProgress/DirectPaymentCard'
import styled from 'styled-components'

const FundingActivityTableWrapper = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-top: 12px;
    thead {
        border-top: 1px solid grey;
        border-bottom: 1px solid grey;
        font-weight: 500;
        color: #595959;
        font-size: 12px;
        cursor: auto;
        user-select: none;
        td:last-child {
            text-align: right;
            padding: 8px 0px;
        }
    }

    tbody {
        tr {
            cursor: pointer;
            transition: 100ms ease-in-out;
            &:hover {
                background: #e7f9fa;
            }
        }
        td {
            height: 47px;
        }
        td:last-child {
            text-align: right;
        }
    }
`

export const FundingActivity: React.VFC<{ payments: FullPaymentFragment[] }> = ({ payments }) => {
    const [open, setOpen] = useState(false)
    const [payment, setPayment] = useState<FullPaymentFragment>()
    const isEmpty = !payments?.length

    const onClickPayment = (p: FullPaymentFragment) => () => {
        setPayment(p)
        setOpen(true)
    }

    return (
        <div>
            <Spacer height={32} />
            {!isEmpty && (
                <>
                    <Body.Med size={14}>Funding activity</Body.Med>
                    <FundingActivityTableWrapper>
                        <thead>
                            <tr>
                                <td>Transaction</td>
                                <td>Status</td>
                                <td>Amount added</td>
                            </tr>
                        </thead>
                        <tbody>
                            {payments.map((p) => (
                                <tr key={p.id} onClick={onClickPayment(p)}>
                                    <td>
                                        <Body.Med size={12}>
                                            {dayjs(p.createdAt).format('MMMM D, YYYY')}
                                        </Body.Med>
                                    </td>
                                    <td>
                                        <StatusBadge status={p.status} />
                                    </td>
                                    <td>
                                        <Body.Med size={14}>{formatCurrency(p.amount)}</Body.Med>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </FundingActivityTableWrapper>
                </>
            )}

            <Dialog open={open} onClose={() => setOpen(false)}>
                <Dialog.Content minWidth={418}>
                    <ContentSizer>
                        <Spacer height={24} />
                        <ContentContainer>
                            <DirectPaymentCard payment={payment!} embedded />
                        </ContentContainer>
                        <Spacer height={16} />
                    </ContentSizer>
                </Dialog.Content>
            </Dialog>
        </div>
    )
}
